module.exports = __webpack_public_path__ + "img/logo.c7de6e41.png";